// extracted by mini-css-extract-plugin
export default {"title":"Title_title__+o9Ms","horizontalLine":"Title_horizontalLine__8-Mfk"};